import { createContext, useState } from 'react';
import API from 'services/api';
// import _ from "lodash"

export const OfficeActionContext = createContext({});

let tokenGoogle = localStorage.getItem('google_token');

const OfficeActionProvider = props => {
	const [oaLists, setOALists] = useState([]);
	const [oaEvents, setOAEvents] = useState([]);
	const [oaEventDetail, setOAEventDetail] = useState(null);

	// OA
	const getOALists = params => {
		API.getOALists(params)
			.then(res => {
				const { data } = res;
				setOALists(data);
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const getfEventbyID = params => {
		return API.getfEventbyID(params)
			.then(res => {
				const { data } = res;
				let newObj = {
					...data,
					respondentMark: {
						...data?.respondentMark,
						class:
							data?.respondentMark?.class?.length > 0
								? data?.respondentMark?.class
								: [
										{
											numberClass: '',
											descriptionClass: '',
										},
								  ],
					},
				};
				setOAEventDetail(newObj);
				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getfEvent = params => {
		API.getfEvent(params)
			.then(res => {
				const { data } = res;
				setOAEvents(data);
				// console.log('data oa merek', data);
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const postfEvent = (data, signal) => {
		API.postfEvent(data, signal)
			.then(res => {
				const { data } = res;
				// getfEvent()
				return data;
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const putManyfEvent = data => {
		API.putManyfEvent(data)
			.then(res => {
				const { data } = res;
			})
			.catch(err => {
				console.log('err', err);
			});
	};

	const putfEvent = (id, data) => {
		return API.putfEvent(id, data)
			.then(res => {
				const { data } = res;

				return data;
			})
			.catch(err => {
				return err;
			});
	};

	return (
		<OfficeActionContext.Provider
			value={{
				oaLists,
				oaEvents,
				oaEventDetail,
				setOAEventDetail,

				getOALists,
				getfEventbyID,
				getfEvent,
				postfEvent,
				putfEvent,
				putManyfEvent,
			}}
			{...props}
		/>
	);
};

export default OfficeActionProvider;
